import { envBool, envString } from '@/env'

// Paths that remain accessible even when the HubSpot redirect is active.
const EXEMPT_PATHS = ['/tuition']

function isExemptPath(pathname: string): boolean {
	const normalized = pathname.replace(/\/+$/, '').toLowerCase() || '/'
	return EXEMPT_PATHS.includes(normalized)
}

export default function handleHubspotRedirect(): boolean {
	const enabled = envBool('VITE_HUBSPOT_REDIRECT_ENABLED')
	const url = envString('VITE_HUBSPOT_REDIRECT_URL')

	if (enabled && url && !isExemptPath(window.location.pathname)) {
		window.location.replace(url)
		return true
	}

	return false
}
